/**
 * Public API surface for the Dialog Orchestration System.
 *
 * Engine (framework-agnostic) lives here; React bindings live under `./react`.
 */
export * from "./types";
export {DialogOrchestrator} from "./orchestrator";
export {DialogRegistry} from "./dialog-registry";
export {QueueManager, buildRequest, makeInstanceId} from "./queue-manager";
export {PolicyEngine} from "./policy-engine";
export type {PolicyDecision, DenyReason} from "./policy-engine";
export {CooldownManager} from "./cooldown-manager";
export type {CooldownStorage} from "./cooldown-manager";
export {ZIndexManager} from "./z-index-manager";
export {FlowManager} from "./flow-manager";
export type {FlowLock, FlowLockInput, FlowDecision} from "./flow-manager";
export {LifecycleManager} from "./lifecycle-manager";
export {DialogEventEmitter} from "./event-emitter";

export {DIALOG_CONFIGS} from "./config/dialogs.config";
export {FLOWS} from "./config/flows.config";
export {getOrchestrator, __resetOrchestrator} from "./singleton";
